export default {
  'ec.footer.window': '"Single Window" for International Trade in the Trade Zone',
  'ec.footer.policy': 'Heilongjiang government services',
  'ec.footer.depart': 'Harbin enterprises set up through trains',
}